import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { processDesc, addCost, CARD_TYPE, CARD_CATEGORY } from '../shared/parse';
import { BANNER_COLOR } from '../shared/types';

import style from './popular.scss';
import { deFriendlyURL, friendlyURL } from '../shared/utils';
import { DATA_AREAS, DATA_CLASSES, DATA_EVENTS, DATA_MONSTERS, DATA_STATUS } from '../data/sources';

export class PopularComponent extends LitElement {

    static get properties() {
        return {
            data: Object,
            url: String
        }
    }

    constructor() {
        super();
        this.url = null;
        this.data = null;
        this.imageurl = 'icons';
        this.title = '';
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        let path = deFriendlyURL(this.url.substr(1)||'').split('/');
        this.fetchData(path[0],path[1]);
    }

    async fetchData(type,id) {        
        if(type.toLowerCase() === 'card'){
            let cardjson = await fetch(`./api/card/${id}`);
            let card = await cardjson.json();
            this.imageurl = 'icons';
            this.title = 'Cards';
            this.data = card;                    
        }
        if(type.toLowerCase() === 'monster'){
            this.imageurl = 'monsters';
            this.title = 'Monsters';
            this.data = DATA_MONSTERS.filter(c=>c.name===id)[0];            
        }
        if(type.toLowerCase() === 'area'){
            this.imageurl = 'area';
            this.title = 'Cantos';
            this.data = DATA_AREAS.filter(c=>c.name===id)[0];            
        }
        if(type.toLowerCase() === 'event'){
            this.imageurl = 'events';
            this.title = 'Events';
            this.data = DATA_EVENTS.filter(c=>c.name===id)[0];            
        }
        if(type.toLowerCase() === 'status'){
            this.imageurl = 'status';
            this.title = 'Status';
            this.data = DATA_STATUS.filter(c=>c.name===id)[0];            
        }
        if(type.toLowerCase() === 'class'){
            this.imageurl = 'classes';
            this.title = 'Class';
            this.data = DATA_CLASSES.filter(c=>c.name===id)[0];            
        }
    }

    render() {
        if(!this.data)
            return '';                
        return html`
            <h3>Popular Page</h3>
            <div class="line">
                <h4><a href=${this.url}>${this.title} > ${(this.data.caption||this.data.areaName||this.data.name||'').replace('<br>',' ')}</a></h4>
                <p>${unsafeHTML(processDesc(this.data.description||this.data.desc))}</p>
                ${this.imageurl !== 'area' ? html`
                <div class="artwork" 
                    style="background-image:url(./images/${this.imageurl}/${(this.data.artwork||'').replace(/ /g,'%20')}.webp);"></div>
                `:''}                
            </div>
        `;
    }
}

customElements.define('popular-component', PopularComponent);